import { PlanModel } from '../../core/models/plan-response.model';

export const getEffectiveSubsidizedPrice = (plan: PlanModel, aptc: number | null | undefined): number | null => {
  const price = plan.price ?? null;
  if (price == null) return null;

  if (aptc != null && aptc > 0) {
    return Math.max(0, price - aptc);
  }

  return null;
};

export const hasSavings = (plan: PlanModel, aptc: number | null | undefined): boolean => {
  const price = plan.price ?? null;
  if (price == null) return false;

  const subsidized = getEffectiveSubsidizedPrice(plan, aptc);
  if (subsidized == null) return false;

  return subsidized < price;
};

export const getSavingsAmount = (plan: PlanModel, aptc: number | null | undefined): number => {
  if (!hasSavings(plan, aptc)) return 0;
  return Math.max(0, (plan.price || 0) - (getEffectiveSubsidizedPrice(plan, aptc) || 0));
};

export const getDisplayPrice = (plan: PlanModel, aptc: number | null | undefined): number => {
  const price = plan.price ?? null;
  const subsidized = getEffectiveSubsidizedPrice(plan, aptc);

  if (subsidized != null) {
    return subsidized;
  }
  if (price != null) {
    return price;
  }
  return 0;
};
